import React, { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../Common/DataTable';
// import ComponentSendEmailModel from './ComponentSendEmailModel';
// import { getCustomerContactList } from '../../oilReport/redux/oilReportSlice';
import { RootState } from '../../../redux/rootState';
import { DueListDataTypes } from '../utils/types';
import ComponentInspectionLetterEmailModal from './ComponentInspectionLetterEmailModal';
import { getDueListDataStart, setFiltersData } from '../redux/sliceInspectionLetter';
import { setLoader } from '../../../redux/loaderSlice';
import { convertDateFormat, stripCustPrefix } from '../../../utils/CommonFunctions';
import DueActionConfirmationModal from './DueActionConfirmationModal';
import { resetEmailFlag } from '../../oilReport/redux/oilReportSlice';
import { defaultPageSize } from '../../../utils/Constant';

function InspectionLetterTableComponent() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [data, setData] = useState<DueListDataTypes[]>([]);
  const [ids, setIds] = useState<string[]>([]);
  const [showInspectionLetterEmailModal, setShowInspectionLetterEmailModal] = useState(false);
  const {
    selectedTab, filersData, dueListData, isLoading,
  } = useSelector((state: RootState) => state.inspectionLetterReducer);
  const { isJOFlagAdded } = useSelector((state: RootState) => state.oilReportReducer);

  const columns = useMemo(() => {
    const baseColumns = [
      { key: 'custId', label: 'Customer ID' },
      { key: 'siteName', label: 'Site' },
      { key: 'location', label: 'Location' },
      { key: 'vesselName', label: 'Vessel' },
      { key: 'model', label: 'Model' },
      { key: 'serialNumber', label: 'Serial #' },
      { key: 'lastTested', label: 'Last-Tested' },
      { key: 'reTestDate', label: 'Re-Test Date' },
    ];

    const allCustIdsSame = dueListData?.ReInspections?.every((item) => item.CustId === dueListData?.ReInspections[0].CustId);

    if (allCustIdsSame && filersData?.customerId?.length > 0) {
      baseColumns.splice(0, 0, { key: 'sn', label: '' });
    }

    if (selectedTab !== 2 && selectedTab !== 3 && selectedTab !== 4) {
      if (allCustIdsSame && filersData?.customerId?.length > 0) {
        baseColumns.splice(1, 0, { key: 'action', label: 'Action' });
      } else {
        baseColumns.splice(0, 0, { key: 'action', label: 'Action' });
      }
    }

    return baseColumns;
  }, [dueListData, selectedTab, filersData?.customerId]);

  const tableData: DueListDataTypes[] = useMemo(() => {
    if (dueListData?.ReInspections?.length > 0) {
      const transformedData = dueListData?.ReInspections?.map((ele) => ({
        action: 'close',
        siteName: ele?.SiteName,
        custId: stripCustPrefix(ele?.CustId),
        custName: ele?.CustName,
        location: ele?.Location,
        vesselName: ele?.VesselName,
        model: ele?.Model,
        serialNumber: ele?.SerialNumber,
        jobOrder: ele?.JobOrder,
        vesselId: ele?.VesselId,
        lastTested: convertDateFormat(ele?.LastTested),
        reTestDate: convertDateFormat(ele?.ReTestDate),
        id: `${String(ele?.JobOrder)}_${ele?.VesselId}`,
        isChecked: ids.includes(`${String(ele?.JobOrder)}_${ele?.VesselId}`),
      }));
      return transformedData;
    }
    return [];
  }, [dueListData, ids]);

  useEffect(() => {
    if (tableData) {
      setData(tableData);
    }
  }, [tableData]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleButtonClick = () => {
    setShowInspectionLetterEmailModal(!showInspectionLetterEmailModal);
    // const jobIds: string[] = [];
    // data?.forEach((element) => {
    //   if (element?.isChecked) {
    //     jobIds.push(element?.id);
    //   }
    // });
    // const payload = {
    //   selectedIds: jobIds,
    // };
    // debugLog(payload);
    // const emailString = payload.selectedIds.join(', ');
    // setEmailsData(emailString);
    // setOpen(true);
  };

  const handleData = (clear?: boolean) => {
    const payload = {
      customerId: clear ? '' : (filersData.customerId || ''),
      siteId: clear ? '' : (filersData.siteId || ''),
      fromDate: clear ? '' : (filersData.fromDate || ''),
      toDate: clear ? '' : (filersData.toDate || ''),
      page: clear ? 1 : page,
      rowsPerPage,
      searchQuery: clear ? '' : searchQuery,
      type: selectedTab,
      sortCol,
      sortDir,
    };
    dispatch(getDueListDataStart(payload));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  useEffect(() => {
    if (isJOFlagAdded) {
      handleData();
      setIds([]);
      dispatch(resetEmailFlag());
    }
  }, [isJOFlagAdded]);

  const handleFilterClear = () => {
    const filtersData = {
      fromDate: null,
      toDate: null,
      customerId: '',
      siteId: '',
      dateRangeData: null,
    };
    dispatch(setFiltersData(filtersData));
  };

  useEffect(() => {
    if (searchQuery?.length > 0 || page > 1) {
      setSearchQuery('');
      setPage(1);
    } else {
      handleData();
    }
  }, [filersData]);
  useEffect(() => {
    handleFilterClear();
    handleData(true);
  }, [selectedTab]);

  const handleCheckBoxWithKey = (id: string) => {
    if (ids.includes(id)) {
      const filtered = ids.filter((item) => item !== id);
      setIds(filtered);
    } else {
      setIds([...ids, id]);
    }
  };

  //   useEffect(() => {
  //     dispatch(setLoader(isContactLoading));
  //   }, [isContactLoading]);

  const jobSelected = useMemo(() => data?.every((ele) => !ele?.isChecked), [data]);

  const handleClose = (id: string) => {
    setShowConfirmation(id);
    // const idis = id.split('_');
    // const payload = {
    //   jobOrderId: idis[0],
    //   vesselId: idis[1],
    // };
    // debugLog(id);
    // dispatch(updateStatusForPasDueStart({ payload, callback: handleData }));
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <DataTable<DueListDataTypes>
            data={data}
            columns={columns}
            totalRecords={dueListData?.TotalRecord}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            checkBoxWithKey={['sn']}
            handleCheckBoxWithKey={handleCheckBoxWithKey}
            handleData={handleData}
            filter
            handleEmail={handleButtonClick}
            // handleEmail={selectedTab === 3 ? undefined : handleButtonClick}
            handleClose={handleClose}
            mailIconDisabled={jobSelected}
            customClassName="ReInspectionLetterTableListStyle"
            handleDataFromComponent
          />
        </Grid>
        {/* <Grid item md={12} sm={12} xs={12}>
          <div className="save_and_next_div" style={{ marginTop: '20px' }}>
            <div className="button_margin_left">
              <Button
                type="button"
                disabled={jobSelected}
                onClick={() => handleButtonClick()}
                className="button_save_and_next"
              >
                Save & Next
              </Button>
            </div>
          </div>
        </Grid> */}
      </Grid>
      {showInspectionLetterEmailModal && (
        <ComponentInspectionLetterEmailModal
          show={showInspectionLetterEmailModal}
          setOpenFrom={() => setShowInspectionLetterEmailModal(false)}
          // onClickPreview={onClickPreview}
          customerId={filersData.customerId}
          listData={data?.filter((item) => item?.isChecked)}
        />
      )}
      {showConfirmation && (
      <DueActionConfirmationModal
        show={showConfirmation}
        setOpenFrom={() => setShowConfirmation('')}
        handleCallback={handleData}
      />
      )}
    </>
  );
}

export default InspectionLetterTableComponent;
